import React, { Component } from 'react';
import axios from 'axios';
import {
  Box, Typography, FormControl, Select, TextField, Button,
  Alert, CircularProgress, Collapse, IconButton,
  Table, TableHead, TableRow, TableCell, TableBody,
  Grid, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { NavLink, Navigate } from 'react-router-dom';
import Serverurl from './Apiurl';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DescriptionIcon from '@mui/icons-material/Description';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

class ViewmoreQuotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quote: {},
      servicesWithGallery: [],
      groupedServices: [],
      serviceData: {},
      loading: true,
      error: '',
      success: '',
      followUpDialogOpen: false,
      followUpDate: '',
      followUpComment: '',
      selectedQsId: null,
      logredirect: false,
      pagename: ''
    };
  }
chipStyle = {
  background: "#eaeff3",
  padding: "6px 12px",
  borderRadius: "8px",
  fontSize: "14px",
  border: "1px solid #ddd",
  display: "inline-block"
};

longBoxStyle = {
  background: "#eaeff3",
  padding: "10px 12px",
  borderRadius: "10px",
  border: "1px solid #ddd",
  fontSize: "14px",
  whiteSpace: "pre-line",
  display: "block"
};
  componentDidMount() {
    document.title = "Prep for Sale- Staff Management";
    if (localStorage.getItem("DCuserid") == null) {
      this.setState({ logredirect: true, pagename: '/' });
    }

    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');

    if (id) {
      this.fetchQuote(id);
      this.fetchServicesWithGallery(id);
    } else {
      this.setState({ error: 'Invalid quote ID', loading: false });
    }
  }

  fetchQuote = (id) => {
    axios.get(`${Serverurl}requestaquote/${id}`)
      .then(res => {
        this.setState({ quote: res.data, loading: false });
        this.fetchGroupedServices(id);
      })
      .catch(err => this.setState({ error: err.message, loading: false }));
  };

  fetchServicesWithGallery = (id) => {
    axios.get(`${Serverurl}requestaquote/${id}/servicesgallery`)
      .then(res => this.setState({ servicesWithGallery: res.data }))
      .catch(err => this.setState({ error: err.message }));
  };
fetchFollowups = async (qs_id) => {
  try {
    const res = await axios.get(`${Serverurl}quotesfollowup/get/${qs_id}`);
    return res.data;
  } catch (err) {
    console.error("Followup load error:", err);
    return [];
  }
};
fetchGroupedServices = (rq_id) => {
  
  axios
    .get(`${Serverurl}serviceprovider/serviceprovidergrouped?rq_id=${rq_id}`)
    .then(groupedRes => {

      
      return axios
        .get(`${Serverurl}quoteservices/byQuote/${rq_id}`)
        .then(savedRes => {

          const savedMap = {};
          savedRes.data.forEach(item => {
            savedMap[item.qs_service_id] = item;
          });

          const serviceData = {};
         
          groupedRes.data.data.forEach(item => {
            const saved = savedMap[item.service_id];

            serviceData[item.service_id] = {
              provider: saved ? String(saved.qs_sp_id) : "",
              notes: saved ? saved.qs_notes : "",
              status: saved ? saved.qs_status : 1,
              qs_id: saved ? saved.qs_id : null
            };
          });

          
          const followupPromises = groupedRes.data.data.map(item => {
            const saved = savedMap[item.service_id];

            if (!saved) {
              return Promise.resolve({
                ...item,
                followups: []
              });
            }

            return this.fetchFollowups(saved.qs_id).then(followups => {
  const filtered = followups.filter(f => Number(f.fs_qs_id) === Number(saved.qs_id));
  return {
    ...item,
    followups: filtered
  };
});
          });

         
          return Promise.all(followupPromises).then(withFollowups => {
            return {
              groupedList: withFollowups,
              serviceData
            };
          });
        });
    })

    .then(result => {
      this.setState({
        groupedServices: result.groupedList,
        serviceData: result.serviceData
      });
    })

    .catch(err => {
      this.setState({ error: err.message });
    });
};

  handleServiceChange = (serviceId, field, value) => {
    this.setState(prev => ({
      serviceData: {
        ...prev.serviceData,
        [serviceId]: {
          ...prev.serviceData[serviceId],
          [field]: value,
        },
      },
    }));
  };

handleSubmit = () => {
  const { serviceData, quote } = this.state;
  if (!quote) return;

  const validationErrors = [];
  const servicesPayload = [];

  Object.entries(serviceData).forEach(([serviceId, data]) => {
    const title = `Service ${serviceId}`;
    if (!data?.provider) validationErrors.push(`Please Select provider`);
    if (!data?.notes || data.notes.trim() === '') validationErrors.push(`Please Enter notes`);
    servicesPayload.push({
      serviceId: Number(serviceId),
      spId: Number(data.provider), 
      notes: data.notes || '',
      qs_id: data.qs_id || null,
      qs_status: 2
    });
  });

  if (validationErrors.length > 0) {
    this.setState({ error: validationErrors.join(', '), success: '' });
    return;
  }

  axios.post(`${Serverurl}quoteservices/addOrUpdate`, {
    qs_rq_id: quote.rq_id,
    services: servicesPayload
  })
  .then(res => {
     const returned = res.data.data || [];
     const updatedServiceData = { ...this.state.serviceData };
    returned.forEach(item => {
      const serviceId = item.qs_service_id || item.qs_serviceid || item.serviceId;  
      if (!serviceId) return;
      if (!updatedServiceData[serviceId]) updatedServiceData[serviceId] = {};
      updatedServiceData[serviceId] = {
        ...updatedServiceData[serviceId],
        qs_id: item.qs_id,
        provider: item.qs_sp_id ? String(item.qs_sp_id) : updatedServiceData[serviceId].provider,
        notes: item.qs_notes || updatedServiceData[serviceId].notes,
        status: item.qs_status || updatedServiceData[serviceId].status
      };
    });

    this.setState({
      serviceData: updatedServiceData,
      success: 'Saved successfully!',
      error: ''
    });
  })
  .catch(err => {
    this.setState({ error: err?.response?.data?.error || err.message, success: '' });
  });
};

  updateServiceStatus = (serviceId, newStatus) => {
    const qs_id = this.state.serviceData[serviceId].qs_id;

    if (newStatus === 4) {
      this.setState({ followUpDialogOpen: true, selectedQsId: qs_id });
      return;
    }

    axios.put(`${Serverurl}quoteservices/status/${qs_id}`, { qs_status: newStatus })
      .then(() => {
        this.setState(prev => ({
          serviceData: {
            ...prev.serviceData,
            [serviceId]: {
              ...prev.serviceData[serviceId],
              status: newStatus,
            },
          },
          success: `Service status updated`,
          error: '',
        }));
      })
      .catch(err => this.setState({ error: err.message, success: '' }));
  };

  handleFollowUpSave = () => {
    const { followUpDate, followUpComment, selectedQsId, quote } = this.state;

    if (!followUpDate || !followUpComment) {
      this.setState({ error: 'Please select date and enter comment.' });
      return;
    }

    axios.post(Serverurl + "quotesfollowup/followupadd", {
      fs_rq_id: quote.rq_id,
      fs_qs_id: selectedQsId,
      fs_followupdate: followUpDate,
      fs_comment: followUpComment
    })
      .then(() => {
        this.setState(prev => ({
          followUpDialogOpen: false,
          followUpDate: '',
          followUpComment: '',
          serviceData: {
            ...prev.serviceData,
            [selectedQsId]: {
              ...prev.serviceData[selectedQsId],
              status: 4
            }
          },
          success: 'Follow-up saved successfully!',
          error: ''
        }));
      })
      .catch(err => this.setState({ error: err.message, success: '' }));
  };

  formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
formatNumberOfItems = (jsonString) => {
  try {
    const data = JSON.parse(jsonString);

    const boxes = [];

    if (data.furniture) {
      boxes.push(`Furniture: ${data.furniture}`);
    }

    if (data.ornaments && typeof data.ornaments === "object") {
      const ornamentEntries = Object.entries(data.ornaments)
        .map(([k, v]) => `${k} - ${v}`)
        .join(", ");
      boxes.push(`Ornaments: ${ornamentEntries}`);
    }

    if (data.other && data.other.trim() !== "") {
      boxes.push("-",data.other);
    }

    return boxes;
  } catch (e) {
    return [jsonString]; 
  }
};
filterUniqueServices = (details) => {
  if (!Array.isArray(details)) return details;

  const seen = new Set();
  const filtered = [];

  details.forEach(item => {
    const trimmed = item.trim();

    if (!seen.has(trimmed.toLowerCase())) {
      seen.add(trimmed.toLowerCase());
      filtered.push(trimmed);
    }
  });

  return filtered;
};

renderQASection = () => {
  return (
    <>
      {this.state.servicesWithGallery.map(service => (
        <Accordion
          key={service.sm_id}
          sx={{ mt: 2, borderRadius: 2, overflow: "hidden" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ background: "#EAEFF3" }}
          >
            <Typography variant="h6" fontWeight={600}>
              {service.sm_title}
            </Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ background: "#ffffff", p: 3 }}>
            
    {service.galleryImages?.length > 0 && (
  <PhotoProvider>
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {service.galleryImages
        .flatMap(img =>
          Array.isArray(img.ga_image)
            ? img.ga_image
            : [img.ga_image]
        )
        .map((filename, index) => (
          <Grid item key={index}>
            <PhotoView
              src={`${Serverurl}uploads/${filename}`}
            >
              <img
                src={`${Serverurl}uploads/${filename}`}
                alt={service.sm_title}
                style={{
                  width: 120,
                  height: 90,
                  objectFit: "cover",
                  borderRadius: 4,
                  cursor: "pointer"
                }}
              />
            </PhotoView>
          </Grid>
        ))}
    </Grid>
  </PhotoProvider>
)}

            {service.answers && service.answers.length > 0 ? (
              service.answers.map((answer, idx) => (
                <Box key={idx} sx={{ mb: 3 }}>
                  
                  <Typography variant="subtitle1" fontWeight={500} sx={{ mb: 1 }}>
                    {answer.type}
                  </Typography>

                  {answer.type === "Number of Items" && (
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                      {this.formatNumberOfItems(answer.details[0]).map((item, i) => (
                        <Box key={i} sx={this.chipStyle}>
                          {item}
                        </Box>
                      ))}
                    </Box>
                  )}

                  {answer.type === "When do you need this done" && (
                    <Box sx={this.chipStyle}>
                      {this.formatDate(answer.details[0])}
                    </Box>
                  )}

                  {answer.type === "Type of service" && (
                    <Box sx={this.longBoxStyle}>
                      {this.filterUniqueServices(answer.details).join(", ")}
                    </Box>
                  )}

                  {answer.type !== "Number of Items" &&
                    answer.type !== "When do you need this done" &&
                    answer.type !== "Type of service" && (
                      <Box sx={this.longBoxStyle}>
                        {answer.details.join("\n ")}
                      </Box>
                    )}
                </Box>
              ))
            ) : (
              <Typography>No questions available.</Typography>
            )}

          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

  render() {
    if (this.state.logredirect) {
      return <Navigate to={this.state.pagename} />;
    }

    if (this.state.loading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
          <CircularProgress />
        </Box>
      );
    }

    if (!this.state.quote || Object.keys(this.state.quote).length === 0) {
      return <Alert severity="error">No quote found</Alert>;
    }

    const { quote } = this.state;
    const serviceIds = Array.isArray(quote.rq_sm_id) ? quote.rq_sm_id : [quote.rq_sm_id];

    return (
      <div className="maincontentDiv">


	            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
					
					<Typography variant="h5" gutterBottom  className="contentHeading">
					  Requested Quotes
					</Typography>
            <NavLink to="/ServiceQuote">
              <Button 
			  style={{marginRight: "20px",
    marginTop: "15px"}}
			  size="small" className="frmPrimarybtn" variant="contained" startIcon={<ArrowBackIcon />}>Back</Button>
            </NavLink>
          </Box>
        <Box sx={{ p: 2 }}>
<Box sx={{ mb: 3 }}>
  <Typography variant="h5" gutterBottom>
    {quote.rq_name}
  </Typography>

   <Box
    sx={{
      display: "flex",
      gap: 1.5,
      flexWrap: "wrap",
      mt: 2,
      mb: 1.5
    }}
  >
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 1,
    borderRadius: "20px",
    padding: "6px 14px",
    border: "1px solid #d0d7de",
    cursor: "pointer",
    "&:hover": { backgroundColor: "#f3f6f9" }
  }}
  component="a"
  href={`mailto:${quote.rq_emailid}`}
>
  <EmailIcon fontSize="small" />
  <Typography sx={{ fontSize: "14px", textDecoration: "none", color: "inherit" }}>
    {quote.rq_emailid}
  </Typography>
</Box>

<Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 1,
    borderRadius: "20px",
    padding: "6px 14px",
    border: "1px solid #d0d7de",
    cursor: "pointer",
    "&:hover": { backgroundColor: "#f3f6f9" }
  }}
  component="a"
  href={`tel:${quote.rq_phoneno}`}
>
  <PhoneIcon fontSize="small" />
  <Typography sx={{ fontSize: "14px", textDecoration: "none", color: "inherit" }}>
    {quote.rq_phoneno}
  </Typography>
</Box>
  </Box>

   <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
        padding: "1px 14px",
       mb: 1
    }}
  >
    <LocationOnIcon fontSize="small" />
    <Typography sx={{ fontSize: "14px" }}>
      {quote.rq_address}
    </Typography>
  </Box>
  {/*
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      padding: "1px 14px",
    }}
  >
    <DescriptionIcon fontSize="small" />
    <Typography sx={{ fontSize: "14px" }}>
      {quote.rq_description}
    </Typography>
  </Box>
  */}
</Box>
          <Collapse in={!!this.state.error}>
            <Alert
              severity="error"
              action={
                <IconButton size="small" onClick={() => this.setState({ error: '' })}>
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              {this.state.error}
            </Alert>
          </Collapse>

          {this.state.success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {this.state.success}
            </Alert>
          )}
{this.renderQASection()}
          <Typography pt={5} pb={2} className="contentHeading" variant="h5" textAlign="center">
            Assign Service Provider
          </Typography>
          
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Service</TableCell>
                <TableCell>Provider</TableCell>
                <TableCell>Notes</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {serviceIds.map(service => {
                const id = service.sm_id || service;
                const matchedService = this.state.groupedServices.find(item => Number(item.service_id) === Number(id));
                const status = this.state.serviceData[id]?.status || 1;

                return (
                  <TableRow key={id}>
                    <TableCell>{service.sm_title || `Service ${id}`}</TableCell>

                    <TableCell>
                      {matchedService ? (
                        <FormControl fullWidth>
                          <Select
						  disabled={status === 5 || status === 6}
                            native
                            value={this.state.serviceData[id]?.provider || ''}
                            onChange={e => this.handleServiceChange(id, 'provider', e.target.value)}
                          >
                            <option value="">Select Provider</option>
                            {matchedService.providers.map(p => (
                              <option key={p.id} value={p.id}>{p.name}</option>
                            ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <Alert severity="warning">No providers</Alert>
                      )}
                    </TableCell>
                    <TableCell>
                      <TextField
					  disabled={status === 5 || status === 6}
                        fullWidth
                        multiline
                        rows={2}
                        value={this.state.serviceData[id]?.notes || ''}
                        onChange={e => this.handleServiceChange(id, 'notes', e.target.value)}
                      />
                    </TableCell>

                    <TableCell>

                      {status === 2 && (
                        <Button className="frmPrimarybtn" variant="contained" onClick={() => this.updateServiceStatus(id, 3)}>
                          Sent
                        </Button>
                      )}

                      {(status === 3 || status === 4) && (
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Button size="small" variant="contained" color="info" onClick={() => this.updateServiceStatus(id, 4)}>
                            Follow-up
                          </Button>
                          <Button size="small" variant="contained" color="success" onClick={() => this.updateServiceStatus(id, 5)}>
                            Accept
                          </Button>
                          <Button size="small" variant="contained" color="error" onClick={() => this.updateServiceStatus(id, 6)}>
                            Reject
                          </Button>
                        </Box>
                      )}

                      {status === 5 && <Alert severity="success">Accepted</Alert>}
                      {status === 6 && <Alert severity="error">Rejected</Alert>}
{status !== 5 && status !== 2 && status !== 6 &&
  matchedService?.followups?.length > 0 &&
  matchedService.followups.map((f, idx) => (
    <Box
      key={idx}
      sx={{
        mt: 1,
        p: 1.5,
        border: "1px solid #ccc",
        borderRadius: "8px",
        background: "#f9f9f9"
      }}
    >
      <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
        {this.formatDate(f.fs_followupdate)}
      </Typography>

      <Typography sx={{ fontSize: "14px", mt: 0.5 }}>
        {f.fs_comment}
      </Typography>
    </Box>
  ))
}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Button className="frmPrimarybtn" variant="contained" onClick={this.handleSubmit}>Save</Button>
          </Box>

          <Dialog open={this.state.followUpDialogOpen}
            onClose={() => this.setState({ followUpDialogOpen: false })}>
            <DialogTitle>Follow-Up</DialogTitle>
            <DialogContent>
<Box pt={1}></Box>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker 
    label="Follow-Up Date"
	disablePast
    format="DD-MM-YYYY"
    value={this.state.followUpDate ? dayjs(this.state.followUpDate) : null}
    onChange={(newValue) => {
      this.setState({ followUpDate: dayjs(newValue).format("YYYY-MM-DD") });
    }}
    slotProps={{
      textField: { fullWidth: true }
    }}
  />
</LocalizationProvider>

              <TextField
                label="Follow-Up Comment"
                value={this.state.followUpComment}
                onChange={e => this.setState({ followUpComment: e.target.value })}
                fullWidth
                multiline
                rows={4}
                sx={{ mt: 2 }}
              />
            </DialogContent>

       <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
              <Button className="frmSecondarybtn" onClick={() => this.setState({ followUpDialogOpen: false })}>Cancel</Button>
              <Button className="frmPrimarybtn" onClick={this.handleFollowUpSave}>Save</Button>
            </DialogActions>
          </Dialog>     
        </Box>
      </div>
    );
  }
}

export default ViewmoreQuotes;
